import { faTicketAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core/styles';
import creamPixelsPattern from 'assets/img/cream-pixels.png';
import ticketsStyle from 'assets/jss/material-kit-pro-react/views/landingPageSections/ticketsStyle.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import { Link } from 'gatsby';
import React from 'react';

const useStyles = makeStyles(ticketsStyle);

export default function SectionTickets() {
  const classes = useStyles();
  return (
    <div
      className={classes.section}
      style={{ backgroundImage: `url(${creamPixelsPattern})` }}
      id="tickets"
    >
      <div className={classes.container}>
        <GridContainer alignItems="center">
          <GridItem xs={12} sm={2} className={classes.ticketItem}>
            <FontAwesomeIcon
              icon={faTicketAlt}
              className={classes.ticketIcon1}
            />
          </GridItem>
          <GridItem xs={12} sm={8} className={classes.ticketItem}>
            <Card className={classes.ticketCard} pricing>
              <div
                className={classes.ticketHoleLeft}
                style={{ backgroundImage: `url(${creamPixelsPattern})` }}
              ></div>
              <div
                className={classes.ticketHoleRight}
                style={{ backgroundImage: `url(${creamPixelsPattern})` }}
              ></div>
              <CardBody>
                {/* <h3 className={classes.title}>Tickets Coming Soon</h3> */}
                {/* <p className={classes.description}>
                  <b>
                    Online ticket sales are closed. General admission tickets
                    are still available at the gate.
                  </b>
                </p> */}
                {/* <Button
                  className={classes.ticketButton}
                  href="https://www.eventeny.com/events/ticket/?id=28844&ref=chilimania"
                  color="primary"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Purchase Chilimania tickets (opens in new tab)"
                >
                  Get Tickets Now
                  <ConfirmationNumberIcon />
                </Button> */}
                <p className={classes.description}>
                  Country Edge and Chilimania are separate events and require
                  separate admission tickets.
                </p>
                <hr className={classes.ticketDivider} />
                <p className={classes.description}>
                  General admission tickets will also be available at the gate.
                </p>
                <Link to="/tickets">
                  <Button size="sm" color="secondary">
                    More Admissions Info
                  </Button>
                </Link>
                {/* <Button
                  className={classes.ticketButton}
                  href="https://chilimania.ticketspice.com/chilimania-2025"
                  color="primary"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Purchase Chilimania tickets (opens in new tab)"
                >
                  Chilimania
                  <ConfirmationNumberIcon />
                </Button> */}
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={2} className={classes.ticketItem}>
            <FontAwesomeIcon
              icon={faTicketAlt}
              className={classes.ticketIcon2}
            />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
